import { Component, Inject } from '@angular/core';
import { BreadcrumbService } from "@gea-waldviertler-website/shop-lib";

@Component({
    selector: 'gea-shop-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: [],
    standalone: false
})
export class NewsletterComponent {
  constructor(
    @Inject(BreadcrumbService) private bcService: BreadcrumbService
  ) {
    this.bcService.trackPageView({ label: "Publikationen", link: "newsletter-abonnieren", type: "other" })
  }
}
